<template>

<div id="app">
        <el-container class="flextext">

            <home-head></home-head>
            <el-main>

                <div class="shop_main">
                    
                    
                    <div class="contain contain_qiangzhiquxiaoimportant" style='height:auto;'>
                        <!-- <el-row>
                            <el-col>
                                <h3 class="title" >
                                    {{wiki.title}}
                                </h3>
                            </el-col>
                        </el-row> -->
                        <el-row :gutter="20" class="img-info">
                            

                            <el-col :span="12" class="img-left" >

                                <!-- <img :src="wiki.source_img" alt="" > -->
                                <el-image  class="" :src="wiki.source_img" fit="cover">
                                <div slot="error" class="image-slot">
                                    <img class="weijiazai_img_qiangzhi"
                                         src="../../../assets/home/ecc08ecd42f312b04df547040f2e5f3.png"
                                         alt="" style="height: 360px" width="250px">
                                </div>
                            </el-image>
                            </el-col>
                            
                            <el-col :span="12" class="info-right">

                                <dl>
                                    <dt>名称</dt>  
                                    <dd>{{wiki.title}}</dd>
                                </dl>
                                <dl>
                                    <dt>英文名称</dt>  
                                    <dd>{{wiki.en_title}}</dd>
                                </dl> 
                                <dl>
                                    <dt>品牌</dt>  
                                    <dd>{{wiki.brand}}</dd>
                                </dl> 
                                <dl>
                                    <dt>分类</dt>  
                                    <dd>{{wiki.category}}</dd>
                                </dl>  
                            </el-col>     
                        </el-row>
                        <el-row class="content"  :gutter="20" >
                            
                            <el-col :span="16" >
                                <h3 class="h">详情</h3>
                                <div class="c" style="padding: 10px 30px;">

                                    <el-tabs v-model="activeTabName" @tab-click="handleClick">
                                        <el-tab-pane label="产品主图" name="first">
                                        
                                        <el-image v-for="(mpic,indexm) in wiki.main_pic" v-bind:key="indexm" :src="mpic">
                                        </el-image>
                                        </el-tab-pane>
                                        <el-tab-pane label="产品部位图" name="second">
                                            <el-image v-for="(opic,indexo) in wiki.other_pic" v-bind:key="indexo" :src="opic">
                                            </el-image>
                                        </el-tab-pane>
                                        <el-tab-pane label="产品参数" name="third">
                                            {{wiki.canshu}}
                                        </el-tab-pane>
                                        <el-tab-pane label="产品产业链" name="fourth">
                                            {{wiki.chanyelian}}
                                        </el-tab-pane>
                                        <el-tab-pane label="产品应用领域" name="fifth">
                                            {{wiki.yingyonglingyu}}
                                        </el-tab-pane>
                                    </el-tabs>
                                    
                                </div>
                            </el-col>
                            <el-col :span="8">
                                <h3 class="h">用户补充</h3>
                                <el-form :label-position="'top'">
                                    <el-form-item label="产品照片" >

                                        <el-upload
                                            action="#"
                                            list-type="picture-card"

                                            :on-change="mainPicChange"
                                            :auto-upload="false">
                                            <i slot="default" class="el-icon-plus"></i>
                                            <div slot="file" slot-scope="{file}">
                                            <img
                                                class="el-upload-list__item-thumbnail"
                                                :src="file.url" alt=""
                                            >
                                            <span class="el-upload-list__item-actions">
                                                <span
                                                class="el-upload-list__item-preview"
                                                @click="handlePictureCardPreview(file)"
                                                >
                                                <i class="el-icon-zoom-in"></i>
                                                </span>
                                                <span
                                                v-if="!disabled"
                                                class="el-upload-list__item-delete"
                                                @click="handleMainPicRemove(file)"
                                                >
                                                <i class="el-icon-delete"></i>
                                                </span>
                                            </span>
                                            </div>
                                        </el-upload>

                                    </el-form-item>

                                    <el-form-item label="产品所属部位照片">
                                        
                                        <el-upload
                                            action="#"
                                            list-type="picture-card"

                                            :on-change="otherPicChange"
                                            :auto-upload="false">
                                                <i slot="default" class="el-icon-plus"></i>
                                                <div slot="file" slot-scope="{file}">
                                                <img
                                                    class="el-upload-list__item-thumbnail"
                                                    :src="file.url" alt=""
                                                >
                                                <span class="el-upload-list__item-actions">
                                                    <span
                                                    class="el-upload-list__item-preview"
                                                    @click="handlePictureCardPreview(file)"
                                                    >
                                                    <i class="el-icon-zoom-in"></i>
                                                    </span>
                                                    <span
                                                    v-if="!disabled"
                                                    class="el-upload-list__item-delete"
                                                    @click="handleOtherPicRemove(file)"
                                                    >
                                                    <i class="el-icon-delete"></i>
                                                    </span>
                                                </span>
                                                </div>
                                            </el-upload>

                                    </el-form-item>
                                    <el-form-item label="产品参数及功能等">
                                        <el-input v-model="buchong.canshu"></el-input>
                                    </el-form-item>
                                    <el-form-item label="产品的其它应用领域">
                                        <el-input v-model="buchong.yingyonglingyu"></el-input>
                                    </el-form-item>
                                    <el-form-item label="产品产业链信息">
                                        <el-input v-model="buchong.chanyelian"></el-input>
                                    </el-form-item>
                                    <el-form-item label="">
                                        <el-button @click="do_submit" type="primary">提交</el-button>
                                    </el-form-item>
                                </el-form>
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-col>
                        </el-row>

                        <div class="brand-desc">

                            <div class="brand"></div>   
                            <div class="desc"></div>   
                        </div>

                    </div>
                    <div style="height:100px"></div>

                </div>
            </el-main>
            <footerall></footerall>
        </el-container>
    </div>

</template>

<script>
    import home_head from '../../common/home-head_new';
    import footerall from "../../common/footer";

export default {
  name: "wiki_detail",
  data: function () {
    return {

        
        url:'',
        wiki_id:0,
        wiki:{

        },

        buchong:{
            main_pic:'',
            other_pic:[],
            canshu:'',
            yingyonglingyu:'',
            chanyelian:'',
        },

        mainPicList:[],
        otherPicList:[],
        // 照片墙属性
        dialogImageUrl: '',
        dialogVisible: false,
        disabled: false,

        activeTabName:'first' // 内容选项卡的选中项
    }
  },

  components: {
    'home-head': home_head,
    footerall
  },

  methods:{

    init:function(){

        console.log('百科产品详情页面')
        this.url = window.config.api_url;
        this.wiki_id = this.$route.params.id;
        this.get_detail();
    },

    get_detail:function(){

        var t = this;
        var url = window.config.api_url + '/college/wiki/' + this.wiki_id;
        t.axios.get(url).then((res)=>{
            t.wiki = res.data
        })

    },

    do_search:function(){

    },

    handleMainPicSuccess:function( res, file ){
        this.imageUrl = URL.createObjectURL(file.raw);
        console.log('handleMainPicSuccess', res, file )
    },

    beforeMainPicUpload:function( file ){
        console.log('beforeMainPicUpload', file )
        // const isJPG = file.type === 'image/jpeg';
        const isLt5M = file.size / 1024 / 1024 < 5;

        // if (!isJPG) {
        //   this.$message.error('上传头像图片只能是 JPG 格式!');
        // }
        if (!isLt5M) {
          this.$message.error('上传头像图片大小不能超过 5MB!');
        }
        // return isJPG && isLt2M;
        this.buchong.main_pic = file
    },

    do_submit:function(){

        var t = this;

        var url = window.config.api_url + '/college/wiki/buchong/' + this.wiki_id;


        let formData = new FormData();
        // formData.append('main_pic', this.buchong.main_pic);

        this.mainPicList.forEach( res=>{
            formData.append('main_pic[]', res.raw );
        })

        this.otherPicList.forEach( res=>{
            formData.append('other_pic[]', res.raw );
        })

        formData.append('chanyelian', this.buchong.chanyelian);
        formData.append('yingyonglingyu', this.buchong.yingyonglingyu);
        formData.append('canshu', this.buchong.canshu);
        t.axios.post( url, formData ).then((res)=>{

            console.log( res )

            // todo 清空内容
            // todo 给出提交成功提示

        })

    },

    /* 照片墙方法 */
    handleOtherPicRemove(file) {
        
        console.log( ' handleOtherPicRemove' );
        let n = this.otherPicList.indexOf( file )
        this.otherPicList.splice( n, 1 );
    },

    handleMainPicRemove(file) {
        
        console.log( ' handleMainPicRemove' );
        let n = this.mainPicList.indexOf( file )
        this.mainPicList.splice( n, 1 );
    },

    handlePictureCardPreview(file) {

        
        console.log( file ) 

        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
        
        return;
    },

    mainPicChange:function(file, fileList){
        this.mainPicList = fileList;
    },

    otherPicChange:function(file, fileList){
        this.otherPicList = fileList;
    }

  },

  created:function(){

    this.init();
  }

  
}
</script>

<style lang="less" scoped>
    @import "../../../../node_modules/element-ui/lib/theme-chalk/display.css";

    @head_text: Source Han Sans CN;
    @font-face {

    }

    @import "../../../assets/css/home";
    @import "../../../assets/css/home_details";
    //@import "../../../assets/css/goods_detailed";
    .flextext {
        display: flex;
        flex-direction: column;
        flex: 1;
        flex-basis: auto;
        box-sizing: border-box;
        min-width: 0;
    }

    .btncss {
        position: absolute;
    }
</style>

<style lang="less" scoped>

.shop_main{
    // max-width: 1200px;
    // width: 80%;
    margin:0 auto;
    
    .contain{
        margin-top:10px;
    }
}
.title{
    font-weight:bold;
    font-size:16px;
    margin: 10px 0;
}
.img-left{
    img{
        width:100%;
    }
}
.info-right{
    dl{

        display:flex;
        line-height:2;
        font-size:16px;
        dt{

            font-weight:bold;

            width:80px;
            &::after{
                // display:block;
                content:":";
            }
        }

        dd{

        }
    }
}
.content{

    margin-top:30px;
    h3{

        &.h{
            border-bottom:solid 3px #4E6EF2 ;
            padding:5px 10px;
            font-size:16px;
            font-weight:bold;
        }

    }

    .c{
        p{
            text-indent: 26px;
           margin-top: 10px;
        }


    }
}
</style>

<style>
/**  upload上传组件样式   */
.el-upload--picture-card {

    width:100px!important;
    height:100px!important;
    line-height:100px!important;
}
.el-upload-list--picture-card .el-upload-list__item{
    width:100px!important;
    height:100px!important;
}



</style>